import React from 'react';
import { twMerge } from 'tailwind-merge';
import IconClear from '../../components/images/IconClear.jsx';
import IconSave from '../../components/images/IconSave.jsx';

const AfterMeetingListItem = ({ text, isMarked, onMark, onUnmark, className, isLoading }) => {
    return (
        <div className={twMerge('flex justify-between py-3 w-full space-x-4', className)}>
            <span className={`text-theme1-goldDark text-[16px] ${isMarked ? 'font-bold' : ''}`}>{text}</span>

            <div className='flex space-x-4 items-start mt-[5px]'>
                {!isMarked && (
                    <button onClick={onMark} disabled={isLoading}>
                        <IconSave className='w-6 h-6 fill-theme1-goldDark' />
                    </button>
                )}

                {isMarked && (
                    <button onClick={onUnmark} disabled={isLoading}>
                        <IconClear className='w-6 h-6 fill-theme1-goldDark' />
                    </button>
                )}
            </div>
        </div>
    );
};

export default AfterMeetingListItem;
